import React, { useState } from "react";
import Spinner from "../../../../../common/spinner";
import { useSelector } from "react-redux";
import apiCall from "../../../../../../apicall";

const ConfirmationActiveJobType = ({ jobId, getJobType, setErrSuccessMsg }) => {
    const { TOKEN } = useSelector((state) => state.menu);
    const [isLoading, setIsLoading] = useState(false);
    const [isJobTypeActivated, setIsJobTypeActivated] = useState(false);
    console.log("jobIdjobIdjobIdjobIdjobId", jobId)

    const displayErrMsg = (errMsg) => {
        setErrSuccessMsg({
            message: errMsg,
            status: false,
        });
        setIsLoading(false);
        setIsJobTypeActivated(false);
    };

    const handleJobTypeActive = async () => {
        try {
            setIsLoading(true);
            const activeJobResponse = await apiCall(
                `openstaff/jobs/${jobId}/ActivateJobType`,
                "PUT",
                null,
                TOKEN
            );
            console.log("activeJobResponse----", activeJobResponse);
            if (activeJobResponse?.status === 200) {
                setIsLoading(false);
                setIsJobTypeActivated(true);
                const modalElement = document.getElementById('active_job_type_popup');
                if (modalElement) {
                    const modal = window.bootstrap.Modal.getInstance(modalElement);
                    if (modal) {
                        modal.hide();
                    }
                }

                setErrSuccessMsg({
                    message: "Profession has been enabled!",
                    status: true,
                });

                setTimeout(() => {
                    getJobType();
                }, 1000);
            } else if (activeJobResponse?.response?.status == 401) {
                displayErrMsg("Your session has been expired!");
            } else {
                displayErrMsg(activeJobResponse?.response?.data?.message);
            }
        } catch (err) {
            console.log("setSessionExpired--", err);
            displayErrMsg("Something went wrong!");
        }
    };

    return (
        <div
            className="modal fade twm-sign-up"
            id="active_job_type_popup"
            aria-hidden="true"
            aria-labelledby="deleteJobPopupLabel"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2 className="modal-title" id="deleteJobPopupLabel">
                            Are you sure you want to enable the profession?
                        </h2>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setIsJobTypeActivated(false)}
                        />
                    </div>
                    <div className="modal-footer">
                        <>
                            <button
                                type="button"
                                id="deleteConfirmationModal"
                                className="btn btn-success"
                                onClick={handleJobTypeActive}
                            >
                                {isLoading ? <Spinner /> : "Yes"}
                            </button>
                        </>
                        <button
                            type="button"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                            onClick={() => setIsJobTypeActivated(false)}
                        >
                            No
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationActiveJobType;